// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { createClientLogger } from "@azure/logger";

/**
 * The `@azure/logger` configuration for this package.
 */
export const logger = createClientLogger("storage-file-datalake");
